export const convertToRoman = (number: number) =>
	({
		1: 'I',
		2: 'II',
		3: 'III',
		4: 'IV',
	}[number]);
